import { Enrollment } from '../../lib/types/models/enrollment/enrollment'
import { OtoIndividualPropositionRequest } from '../../lib/types/models/enrollment-proposition/oto-individual-proposition-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createOtoIndividualProposition(data: IdInput<OtoIndividualPropositionRequest>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.enrollments.createOtoIndividualProposition.url, { id }))
    .post<Pick<Enrollment, 'id' | 'propositionType'>, OtoIndividualPropositionRequest>(rest)
}
